module.exports = __webpack_public_path__ + "assets/img/ae3a09a8cf701bcedbdd9b59104234c4.svg";